import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, PickerDialog, Textarea } from '@wit-support/ui';
import { STATUS_LABEL_RU } from '@wit-support/ui-domain';
import { useBulkAction } from './use-bulk-action.js';
import { STATUS_OPTIONS } from './status-control.js';
/**
 * Bulk «Статус» dialog: pick ONE target status and apply it to every selected
 * conversation via the shared bulk mutation (`change_status`).
 *
 * Комментарий здесь — ОДИН на всю пачку: сервер кладёт его копию каждому
 * диалогу, как если бы оператор написал одно и то же в каждом. Это ровно то,
 * ради чего массовая смена и делается («закрываю сентябрьский спам»), а поле на
 * каждый диалог в массовом действии не имело бы смысла.
 */
export function BulkStatusDialog({ open, conversationIds, onOpenChange }) {
    const [status, setStatus] = useState(null);
    const [comment, setComment] = useState('');
    // useBulkAction owns the post-apply selection handling (exit on full success /
    // narrow to the failed subset on partial failure); the dialog just closes.
    const mut = useBulkAction(() => {
        onOpenChange(false);
        setStatus(null);
        setComment('');
    });
    const count = conversationIds.length;
    return (_jsx(PickerDialog, { open: open, onOpenChange: onOpenChange, busy: mut.isPending, onReset: () => {
            setStatus(null);
            setComment('');
        }, size: "sm", title: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0441\u0442\u0430\u0442\u0443\u0441", description: _jsxs(_Fragment, { children: ["\u041D\u043E\u0432\u044B\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u0431\u0443\u0434\u0435\u0442 \u043F\u0440\u0438\u043C\u0435\u043D\u0451\u043D \u043A ", count, " ", count === 1 ? 'диалогу' : 'выбранным диалогам', "."] }), footer: _jsx(Button, { type: "button", onClick: () => {
                if (!status)
                    return;
                const trimmed = comment.trim();
                mut.mutate({
                    conversationIds,
                    // Пустой комментарий НЕ отправляется вовсе: контракт ждёт непустую
                    // строку, и `''` вернулся бы 422 вместо «заметки не было».
                    action: trimmed.length > 0
                        ? { type: 'change_status', status, comment: trimmed }
                        : { type: 'change_status', status },
                });
            }, disabled: !status || mut.isPending || count === 0, children: mut.isPending ? 'Применение…' : 'Применить' }), children: _jsxs("div", { className: "flex flex-col gap-3", children: [_jsx("div", { className: "grid grid-cols-2 gap-2", children: STATUS_OPTIONS.map((s) => (_jsx(Button, { type: "button", variant: status === s ? 'primary' : 'secondary', onClick: () => setStatus(s), disabled: mut.isPending, children: STATUS_LABEL_RU[s] }, s))) }), _jsx(Textarea, { value: comment, onChange: (event) => setComment(event.target.value), "aria-label": "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)", placeholder: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)", rows: 3, disabled: mut.isPending, className: "min-h-16 text-sm" })] }) }));
}
//# sourceMappingURL=bulk-status-dialog.js.map